module.exports = "/static/media/android.e638d308.svg";